import {
  Box,
  ButtonGroup,
  DialogActions,
  FormControl,
  FormHelperText,
  IconButton,
  Typography,
} from "@mui/material";
import MaterialInput from "../../components/MaterialInput";
import MaterialSelect from "../../components/MasterSelect";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { motion } from "framer-motion";
import { Percent } from "@mui/icons-material";

const MotionIconButton = motion(IconButton);

const AppointmentLetter = ({
  recruitmentdata,
  SalaryStructure,
  setOpen,
  handlerecruitmentchange,
  setrecruitmentdata,
  handleoffer,
  OfferleterUpdate,
}) => {
  const nav = useNavigate();
  const ViewOfferletter = () => {
    nav("/appointment", { state: recruitmentdata?.appointmentletterid });
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            Employee Code <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            value={recruitmentdata.empCode}
            name="Ctc"
            onChange={(e) => handlerecruitmentchange("empCode", e.target.value)}
            error={recruitmentdata.empCodeStatus === "error"}
            success={recruitmentdata.empCodeStatus === "success"}
            variant="outlined"
            size="small"
          />
          {recruitmentdata.empCodeStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Enter a valid Salary (5 to 7 digits)
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            CTC PA <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            value={recruitmentdata?.appointmentctc}
            name="Ctc"
            onChange={(e) =>
              handlerecruitmentchange("appointmentctc", e.target.value)
            }
            error={recruitmentdata.appointmentctcStatus === "error"}
            success={recruitmentdata.appointmentctcStatus === "success"}
            variant="outlined"
            size="small"
          />
          {recruitmentdata.appointmentctcStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Enter a valid Salary (5 to 7 digits)
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            Salary Structure <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialSelect
            name="salarystructure"
            value={recruitmentdata.appointmentsalaryStructure}
            onChange={(e) =>
              handlerecruitmentchange("appointmentsalaryStructure", e)
            }
            options={SalaryStructure.map((value) => ({
              value: value?.id,
              label: value.structureName,
            }))}
            error={recruitmentdata.appointmentsalaryStructureStatus === "error"}
            success={
              recruitmentdata.appointmentsalaryStructureStatus === "success"
            }
            size="small"
            isClearable
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            Basic Percentage <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            value={recruitmentdata.appointmentbasicPercentage}
            name="basicPercentage"
            icon={{
                  component: (
                    <Percent />
                  ),
                  direction: 'right',
                  type: 'icon'
                }}
            onChange={(e) =>
              handlerecruitmentchange(
                "appointmentbasicPercentage",
                e.target.value
              )
            }
            variant="outlined"
            size="small"
            error={recruitmentdata.appointmentbasicPercentageStatus === "error"}
            success={
              recruitmentdata.appointmentbasicPercentageStatus === "success"
            }
          />
          {recruitmentdata.basicPercentageStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Basic Percentage must contain only numbers
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            Joining Date <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            type="date"
            name="joiningdate"
            value={recruitmentdata.appointmentdate}
            onChange={(e) =>
              handlerecruitmentchange("appointmentdate", e.target.value)
            }
            error={recruitmentdata.appointmentdateStatus === "error"}
            success={recruitmentdata.appointmentdateStatus === "success"}
            variant="outlined"
            size="small"
           
          />
        </Grid>
      </Grid>
      <DialogActions sx={{ justifyContent: "center", gap: 2, py: 1 }}>
        <MotionIconButton
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          onClick={() => {
            setOpen(false);
            setrecruitmentdata({});
          }}
          sx={{
            backgroundColor: "#ffebee",
            color: "red",
            "&:hover": {
              backgroundColor: "#ffcdd2",
              transform: "scale(1.1)",
            },
          }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <CloseIcon />
        </MotionIconButton>

        {recruitmentdata?.appointmentletterid ? (
          <>
            <MotionIconButton
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.1 }}
              onClick={OfferleterUpdate}
              sx={{
                backgroundColor: "#e8f5e9",
                color: "green",
                "&:hover": {
                  backgroundColor: "#c8e6c9",
                },
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <EditIcon />
            </MotionIconButton>

            <MotionIconButton
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.2 }}
              onClick={ViewOfferletter}
              sx={{
                backgroundColor: "#e8f5e9",
                color: "green",
                "&:hover": {
                  backgroundColor: "#c8e6c9",
                },
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <VisibilityIcon />
            </MotionIconButton>
          </>
        ) : (
          <MotionIconButton
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.1 }}
            onClick={handleoffer}
            sx={{
              backgroundColor: "#E3E9F7",
              color: "#0B1D51",
              "&:hover": {
                backgroundColor: "#CDD7F3",
              },
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <AddIcon />
          </MotionIconButton>
        )}
      </DialogActions>
    </>
  );
};
export default AppointmentLetter;
